const initState = {
  segmentationResult: {},
  segmentationHistoryData: {},
  segmentationUserParams: {},
  creatorId: '',
  list: [],
  queryApi: Promise.reject()
};

const segmentation = {
  state: initState,
  mutations: {
    RESET_segmentation(state) {
      state = Object.assign(state, initState);
    },
    SET_SEGMENTATION_RESULT(state, result) {

      state.segmentationResult = result;
    },
    SET_SEGMENTATION_HISTORY(state, data) {
      state.segmentationHistoryData = data;
    },
    SET_SEGMENTATION_CREATORID(state, data) {
      state.creatorId = data;
    },
    SET_SEGMENTATION_USER_PARAMS(state, params) {
      state.segmentationUserParams = params;
    },
    SET_SEGMENTATION_LIST (state, data) {
      state.list = data
    },
    SET_QUERY_API (state, promise) {
      state.queryApi = promise
    }
  }
};

export default segmentation;



// WEBPACK FOOTER //
// ./src/store/modules/segmentation.js